export default __webpack_public_path__ + "static/media/masterdata.0644edc7.svg";